export default __webpack_public_path__ + "static/MNSMWHITELIGHTNIN_SATINJACKET_600x600-4fa281669609fcddbe13d52d55f2accc.png";